import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fmttaskpendientes',
  templateUrl: './fmttaskpendientes.component.html',
  styleUrls: ['./fmttaskpendientes.component.scss']
})
export class FmttaskpendientesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
